import type { AxiosInstance } from 'axios';
import { z } from 'zod';
import * as SearchApi from './interfaces/search.js';
import qs from './utils/query-string.js';

export class SearchClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  searchKols = async (params: SearchApi.SearchKols.Request) => {
    return this.authenticatedClient.get<SearchApi.SearchKols.Response>(`/search/kol?${qs.stringify(params)}`).then(r => r.data);
  };

  searchHcpsByName = async (params: SearchApi.SearchHcpsByName.Request) => {
    return this.authenticatedClient.get<SearchApi.SearchHcpsByName.Response>(`/search/hcp?${qs.stringify(params)}`).then(r => r.data);
  };

  searchReps = async (params: SearchApi.SearchReps.Request) => {
    return this.authenticatedClient.get<SearchApi.SearchReps.Response>(`/search/rep?${qs.stringify(params)}`).then(r => r.data);
  };

  searchHcpsByLocation = async (params: SearchApi.SearchHcpsByLocation.Request) => {
    return this.authenticatedClient.get<SearchApi.SearchHcpsByLocation.Response>(`/search/hcp/location?${qs.stringify(params)}`).then(r => r.data);
  };

  searchLocation = async (params: SearchApi.SearchLocation.Request) => {
    return this.authenticatedClient.get<SearchApi.SearchLocation.Response>(`/search/location?${qs.stringify(params)}`).then(r => r.data);
  };

  searchTags = async (params: SearchApi.SearchTags.Request) => {
    const query = qs.stringify({
      query: params.query,
    });

    return this.authenticatedClient.get(`/tags?${query}`).then(r => SearchApi.SearchTags.responseSchema.parse(r.data));
  };
}

export const responseSchema = z.object({
  results: z.object({
    id: z.number(),
    name: z.string(),
  }).required(),
});

export default SearchClient;